interface UnsavedChangesSource {
    group?: string;
    when: () => boolean;
    onDiscard: () => void;
}

const sources = new Map<symbol, UnsavedChangesSource>();
const listeners = new Set<() => void>();

/** Сообщает об изменении защиты открытых редакторов */
export const notifyUnsavedChanges = (): void => listeners.forEach((listener) => listener());

/** Подписывает навигацию на изменения открытых редакторов */
export const subscribeUnsavedChanges = (listener: () => void): (() => void) => {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
};

/** Подключает открытый редактор к общей защите изменений */
export const registerUnsavedChanges = (source: UnsavedChangesSource): (() => void) => {
    const id = Symbol('editor');
    sources.set(id, source);
    notifyUnsavedChanges();

    return () => {
        sources.delete(id);
        notifyUnsavedChanges();
    };
};

/** Проверяет актуальное состояние форм, в том числе сразу после сохранения */
export const hasUnsavedChanges = (group?: string): boolean => (
    Array.from(sources.values()).some((source) => (group === undefined || source.group === group) && source.when())
);

/** Отменяет изменения всех открытых редакторов перед подтверждённым уходом */
export const discardUnsavedChanges = (group?: string): void => {
    const activeSources = Array.from(sources.values()).filter((source) => group === undefined || source.group === group);

    activeSources.forEach((source) => {
        if (source.when()) source.onDiscard();
    });
};
